import { LANGUAGES } from '~/constants/language'
import type { Language } from '~/constants/language'

export default () => {
  const route = useRoute()
  const langStore = useLanguageStore()

  // Compute current language from path
  const currentLocaleCode = computed(() => {
    const [, localeCode] = route.path.split('/')
    if (LANGUAGES.includes(localeCode as Language)) {
      return localeCode
    }
    return langStore.main.code
  })
  const isMainLanguage = computed(() => currentLocaleCode.value === langStore.main.code)
  const localePrefix = computed(() => {
    const [, localeCode] = route.path.split('/')
    if (LANGUAGES.includes(localeCode as Language)) {
      return localeCode
    }
    return ''
  })

  const localePath = (path: string) => localePrefix.value !== '' ? `/${localePrefix.value}${path}` : path
  const basePath = (prefixedPath: string) => {
    if (localePrefix.value !== '') {
      const path = prefixedPath.replace(`/${localePrefix.value}`, '')
      return path === '' ? '/' : path
    }
    return prefixedPath
  }

  const getCurrentLocaleCustom = () => {
    if (localePrefix.value) {
      return localePrefix.value
    }
    return langStore.main.code
  }

  return {
    basePath,
    localePath,
    localePrefix,
    currentLocaleCode,
    isMainLanguage,
    getCurrentLocaleCustom,
  }
}
